import ApplicationReporteModal from './application-report-modal.connect'

export default ApplicationReporteModal
